import {Component, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {Feedback, FeedbackService} from '../../common/services';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '@Common/widgets/general/data-table';
import {DatePipe} from '@angular/common';
import {FeedbackModaleComponent} from './feedback-modale/feedback-modale.component';
import { MatDialog } from '@angular/material/dialog';
import {SubSink} from '@Common/core/utils/subsink';
import {finalize} from 'rxjs/operators';

import {FileSaverService} from '@Services/common';
import {PubSubService} from '../../common/services/pub-sub.service';

@Component({
  selector: 'app-feedbacks',
  templateUrl: './feedbacks.component.html',
  styleUrls: ['./feedbacks.component.scss']
})
export class FeedbacksComponent implements OnInit, OnDestroy {
  dsFeedbacks: MatDataSourceGeneric<Feedback> = new MatDataSourceGeneric<Feedback>();

  @ViewChild(DataTableComponent, { static: true }) dataTable: DataTableComponent;

  extraParams: Map<string, string> = new Map<string, string>();

  subSink = new SubSink();

  columns: ColumnDataTable[] = [
    { columnDef: 'message', header: 'message', display: (row: Feedback) => row.message,
      truncate: true, flex: 20, sort: false },
    { columnDef: 'individu', header: 'qui', display: (row: Feedback) => {
        if (row.commentator_obj && 'first_name' in row.commentator_obj && 'last_name' in row.commentator_obj) {
          return `${row.commentator_obj.first_name} ${row.commentator_obj.last_name}`;
        }

        return '';
      } , sort: false, flex: 10, tooltip: (row) => {
        return row.commentator_obj ? row.commentator_obj.email_pro : '';
      } },

    { columnDef: 'dt_created', header: 'date',
      display: (row: Feedback) => {
        if (row.dt_created) {
          const dp: DatePipe = new DatePipe(this.locale);
          return dp.transform(`${row.dt_created}`, 'dd/MM/yyyy - H:mm');
        }

        return '';
      }, sort: true,  },
    ];

  actions: ActionDataTable[] = [
    { label: 'Afficher', tooltip: 'Afficher le message complet',  icon: 'remove_red_eye', click: (row) => this.afficher(row),  },
  ];

  constructor(@Inject(LOCALE_ID) private locale: string,
              public dialog: MatDialog,
              private fileService: FileSaverService,
              private pubSubSvc: PubSubService,
              private feedBackSvc: FeedbackService) {
    this.dsFeedbacks.daoService = feedBackSvc;
  }

  ngOnInit() {
  }

  afficher(row: Feedback) {
    const dialogRef = this.dialog.open(FeedbackModaleComponent, {
      width: '650px', height: '',  data: row
    });
    dialogRef.updatePosition({top: '80px'});
    this.subSink.sink = dialogRef.afterClosed().subscribe(result => result);
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  ExportAllFeedbacks() {
    this.pubSubSvc.publish('loading', true);

    this.subSink.sink = this.feedBackSvc.exportExcel()
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe((_excel) => {
        const filename = `Messages`;
        this.fileService.FileSave(_excel, filename, 'xlsx');
      });
  }

}
